import { BorderRadius, Color } from '@persona-id/design-tokens';
import { FC } from 'react';
import styled from 'styled-components';

import { WorkflowCanvasCustomEvent } from 'dashboard/components/WorkflowEditor/WorkflowCanvas/constants';
import { stepDecorationsFor } from 'dashboard/components/WorkflowEditor/WorkflowCanvas/utils';
import { BaseNodeProps } from 'dashboard/components-lib/FlowPlotter';
import { WorkflowRunStepStatus } from 'dashboard/models/workflow-step';

const Boundary = styled.div<{ borderColor: Color; filter: string; width: number; height: number }>`
  border: 2px solid ${({ borderColor }) => borderColor};
  border-radius: ${BorderRadius.Lg};
  background-color: ${Color.CoreSlate100};
  cursor: pointer;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  ${({ filter }) => {
    if (filter) {
      return `filter: ${filter}`;
    }
  }}
`;

interface NodeModuleBoundaryProps {
  errored: boolean;
  runStepStatus: WorkflowRunStepStatus | null;
  selected: boolean;
  stepToken: string;
  height: number;
  width: number;
}

const NodeModuleBoundary: FC<NodeModuleBoundaryProps & BaseNodeProps> = ({
  errored,
  runStepStatus,
  selected,
  stepToken,
  height,
  width,
  onNodeCustomEvent,
}) => {
  const { accentColor, filterEffect } = stepDecorationsFor({
    deactivated: false,
    dragged: false,
    errored,
    selected,
    status: runStepStatus,
    surrounded: false,
  });

  return (
    <Boundary
      role='separator'
      borderColor={accentColor}
      filter={filterEffect}
      height={height}
      width={width}
      onClick={() => {
        onNodeCustomEvent({ key: WorkflowCanvasCustomEvent.Select, parentStepToken: stepToken });
      }}
    />
  );
};

export default NodeModuleBoundary;
